import React, { useState, useEffect, forwardRef } from "react";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";
import { useNavigate } from "react-router-dom";
import { FiExternalLink } from "react-icons/fi";
import "../App.css";

const projects = [
  {
    id: 1,
    name: "MDRRMO Training Program Management System",
    description:
      "A Web-based application that enables online and seamless application to training services offered by the MDRRMO-DAET.",
    link: "#",
    images: [
      require("../project-images/Project1/proj1.png"),
      require("../project-images/Project1/proj1-2.png"),
      require("../project-images/Project1/proj1-3.png"),
      require("../project-images/Project1/proj1-4.png"),
    ],
    technologies: ["React", "JavaScript", "Tailwind CSS", "NodeJS"],
    details: "Additional details about Project 1.",
    link: "https://mdrrmo---tpms.web.app/user/",
  },
  {
    id: 2,
    name: "Shopizen",
    description:
      "An e-commerce website where users could be a buyer and a seller. Provides full customization for stores.",
    link: "#",
    images: [
      require("../project-images/Project2/proj2.png"),
      require("../project-images/Project2/proj2-2.png"),
      require("../project-images/Project2/proj2-3.png"),
      require("../project-images/Project2/proj2-4.png"),
      require("../project-images/Project2/proj2-5.png"),
      require("../project-images/Project2/proj2-6.png"),
      require("../project-images/Project2/proj2-7.png"),
    ],
    technologies: ["React", "JavaScript", "Material UI", "NodeJS"],
    details: "Additional details about Project 2.",
    link: "https://shopizen-61d12.web.app/",
  },
  {
    id: 3,
    name: "CNSC Online Feedback System",
    description:
      "This is an online feedback system specifically created for Camarines Norte State College equipped with role-based access, advanced feedback management and more!",
    images: [require("../project-images/Project3/project-3.jpg")],
    technologies: ["React", "Flask", "Express"],
    details: "Additional details about Project 3.",
  },
  {
    id: 4,
    name: "Recipe Mingle",
    description:
      "This is a Recipe Book android application where users can view a step by step instruction on how to cook and prepare your favourite foods!",
    images: [
      require("../project-images/Project4/proj4.jpg"),
      require("../project-images/Project4/proj4.1.jpg"),
      require("../project-images/Project4/proj4.2.jpg"),
      require("../project-images/Project4/proj4.3.jpg"),
      require("../project-images/Project4/proj4.4.jpg"),
    ],
    technologies: ["Java", "Youtube API"],
    details: "Additional details about Project 3.",
  },
  {
    id: 5,
    name: "Quizlet",
    description:
      "This is a Quiz application where students can use to review study materials. Users can create their own set of questions and share those questions on other devices via bluetooth.",
    images: [
      require("../project-images/Project5/proj5.jpg"),
      require("../project-images/Project5/proj5-1.jpg"),
      require("../project-images/Project5/proj5-2.jpg"),
      require("../project-images/Project5/proj5-3.jpg"),
      require("../project-images/Project5/proj5-4.jpg"),
      require("../project-images/Project5/proj5-5.jpg"),
      require("../project-images/Project5/proj5-6.jpg"),
    ],
    technologies: ["Java"],
    details: "Additional details about Project 3.",
  },
  {
    id: 6,
    name: "Rental Home Daet, Camarines Norte",
    description:
      "This is a GUI application built using Java that helps users find the perfect rental homes across Daet, Camarines Norte",
    images: [
      require("../project-images/Project6/proj6.jpg"),
      require("../project-images/Project6/proj6-1.jpg"),
    ],
    technologies: ["Java", "GUI"],
    details: "Additional details about Project 3.",
  },
  {
    id: 7,
    name: "Beach Resort Guest Management System",
    description:
      "This is a GUI application built using Java that helps beach resort in Paracale, Camarines Norte manage and track resort processes.",
    images: [
      require("../project-images/Project7/proj7.jpg"),
      require("../project-images/Project7/proj7-1.jpg"),
    ],
    technologies: ["Java", "GUI"],
    details: "Additional details about Project 3.",
  },
  {
    id: 8,
    name: "MJ Meatshop",
    description:
      "This is an online meatshop store for MJ Meatshop where users can browse and order meat products conveniently.",
    images: [
      require("../project-images/Project8/proj8.jpg"),
      require("../project-images/Project8/proj8-1.jpg"),
      require("../project-images/Project8/proj8-2.jpg"),
      require("../project-images/Project8/proj8-3.jpg"),
      require("../project-images/Project8/proj8-4.jpg"),
      require("../project-images/Project8/proj8-5.jpg"),
    ],
    technologies: ["Javascript", "CSS"],
    details: "Additional details about Project 3.",
  },
  {
    id: 9,
    name: "Immunology Quiz Website",
    description: "This is an online quiz website.",
    images: [
      require("../project-images/Project9/proj9.jpg"),
      require("../project-images/Project9/proj9-1.jpg"),
      require("../project-images/Project9/proj9-2.jpg"),
    ],
    technologies: ["Javascript", "CSS"],
    details: "Additional details about Project 3.",
  },
  {
    id: 10,
    name: "Bored Monkey Chats",
    description: "This is an Omegle random anonymous chat alternative.",
    images: [
      require("../project-images/Project10/proj10-1.jpg"),
      require("../project-images/Project10/proj10-2.jpg")
    ],
    technologies: ["React", "NodeJS", "Socket.io", "Redis", "Express"],
    details: "Additional details about Project 3.",
    link: "https://boredmonkeychats.web.app/",
  },
];

const Projects = forwardRef(({ scrollToSection }, refNav) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [imageIndices, setImageIndices] = useState({});
  const [showDetails, setShowDetails] = useState(false); // New state to control show/hide
  const { ref, inView } = useInView({ triggerOnce: true, threshold: 0.1 });
  const [showIntro, setShowIntro] = useState(true);
  const navigate = useNavigate();

  const [flippedCards, setFlippedCards] = useState(
    Object.fromEntries(projects.map((p) => [p.id, true]))
  );

  const [selectedImage, setSelectedImage] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    if (inView && showIntro) {
      const timeout = setTimeout(() => setShowIntro(false), 2500);
      return () => clearTimeout(timeout);
    }
  }, [inView, showIntro]);

  // Auto-play effect for each project image
  useEffect(() => {
    const interval = setInterval(() => {
      setImageIndices((prev) => {
        const newIndices = {};
        projects.forEach((proj) => {
          const total = proj.images.length;
          newIndices[proj.id] = ((prev[proj.id] || 0) + 1) % total;
        });
        return newIndices;
      });
    }, 3500);
    return () => clearInterval(interval);
  }, []);

  const toggleFlipCard = (id) => {
    setFlippedCards((prev) => ({ ...prev, [id]: !prev[id] }));
  };

  const handleScroll = (e) => {
    const scrollLeft = e.target.scrollLeft;
    const scrollWidth = e.target.scrollWidth;
    const clientWidth = e.target.clientWidth;
    const index = Math.round(
      (scrollLeft / (scrollWidth - clientWidth)) * (projects.length - 1)
    );
    setCurrentIndex(index);
  };

  const handleViewProject = (id) => {
    const project = projects.find((proj) => proj.id === id);
    if (project && project.link) {
      window.open(project.link, "_blank");
    }
  };

  const handleNextImage = (projectId, totalImages) => {
    setImageIndices((prev) => ({
      ...prev,
      [projectId]: ((prev[projectId] || 0) + 1) % totalImages,
    }));
  };

  const handlePrevImage = (projectId, totalImages) => {
    setImageIndices((prev) => ({
      ...prev,
      [projectId]:
        (prev[projectId] || 0) === 0
          ? totalImages - 1
          : (prev[projectId] - 1) % totalImages,
    }));
  };

  return (
    <div
      id="projects"
      ref={(el) => {
        ref(el);
        if (typeof refNav === "function") refNav(el);
        else if (refNav) refNav.current = el;
      }}
      className="py-16 px-6 snap-start"
    >
      <div className="flex justify-center relative mb-12">
        <motion.h2
          className="text-4xl md:text-6xl font-extrabold text-green relative z-10"
          initial={{ opacity: 0, y: -50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
        >
          Projects
        </motion.h2>
        <span
          className="absolute inset-0 blur-2xl opacity-50 animate-glowPulse"
          style={{
            background: "radial-gradient(circle, #00ff00 0%, transparent 70%)",
          }}
        ></span>
      </div>

      {/* Projects Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-10">
        {projects.map((project) => {
          const currentImageIndex = imageIndices[project.id] || 0;
          const isFlipped = flippedCards[project.id] || false;

          return (
            <motion.div
              key={project.id}
              className="relative w-full rounded-xl shadow-2xl bg-gray-900 overflow-hidden perspective-1000"
              initial={{ opacity: 0, y: 50 }}
              animate={{ opacity: inView ? 1 : 0, y: inView ? 0 : 50 }}
              transition={{ duration: 0.8, delay: 0.1 }}
            >
              <div
                className={`relative w-full h-96 perspective-1000 transform-style-preserve-3d transition-transform duration-500 ${
                  isFlipped ? "rotate-y-180" : ""
                }`}
              >
                {/* Front (Images) */}
                <div className="absolute w-full h-full backface-hidden rounded-xl overflow-hidden flex items-center justify-center">
                  <img
                    src={project.images[currentImageIndex]}
                    alt={project.name}
                    className="w-full h-full object-cover cursor-pointer"
                    onClick={() => {
                      setSelectedImage(project.images[currentImageIndex]);
                      setIsModalOpen(true);
                    }}
                  />
                  {/* Overlay button to flip from front */}
                  <button
                    onClick={() => toggleFlipCard(project.id)}
                    className="absolute bottom-4 bg-green bg-opacity-50 text-black px-4 py-2 rounded-full text-sm hover:bg-opacity-80"
                  >
                    Show Details
                  </button>
                </div>

                {/* Back (Details) */}
                <div className="absolute w-full h-full backface-hidden rotate-y-180 bg-gray-800 rounded-xl p-6 flex flex-col justify-between items-center text-center">
                  <div>
                    <h3 className="text-xl md:text-2xl font-bold text-green mb-3">
                      {project.name}
                    </h3>
                    <p className="text-gray-300 mb-4 text-sm">
                      {project.description}
                    </p>
                    <div className="flex flex-wrap gap-2 mb-4 justify-center">
                      {project.technologies.map((tech, idx) => (
                        <span
                          key={idx}
                          className="bg-green text-black text-xs px-3 py-1 rounded-full"
                        >
                          {tech}
                        </span>
                      ))}
                    </div>
                  </div>

                  <div className="flex flex-col sm:flex-row gap-2 mt-4 justify-center w-full">
                    {project.link && (
                      <a
                        href={project.link}
                        target="_blank"
                        rel="noreferrer"
                        className="flex items-center justify-center gap-2 text-green text-sm font-medium hover:underline px-4 py-2 border border-green rounded-full"
                      >
                        Live Site <FiExternalLink />
                      </a>
                    )}
                    <button
                      onClick={() => toggleFlipCard(project.id)}
                      className="bg-green bg-opacity-50 text-black px-4 py-2 rounded-full text-sm hover:bg-opacity-80"
                    >
                      Show Images
                    </button>
                  </div>
                </div>
              </div>
            </motion.div>
          );
        })}
      </div>

      {/* Modal */}
      {isModalOpen && selectedImage && (
        <motion.div
          className="fixed inset-0 bg-black bg-opacity-90 flex items-center justify-center z-50"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          onClick={() => setIsModalOpen(false)}
        >
          <motion.img
            src={selectedImage}
            alt="Full Screen"
            className="max-w-full max-h-full rounded-lg shadow-lg"
            initial={{ scale: 0.8 }}
            animate={{ scale: 1 }}
            transition={{ duration: 0.3 }}
            onClick={(e) => e.stopPropagation()}
          />
          <button
            className="absolute top-6 right-6 text-white text-2xl bg-black bg-opacity-50 rounded-full px-3 py-1 hover:bg-opacity-80"
            onClick={() => setIsModalOpen(false)}
          >
            &times;
          </button>
        </motion.div>
      )}
    </div>
  );
});

export default Projects;
